import { render, staticRenderFns } from "./status-cell.vue?vue&type=template&id=37a5a1ca&scoped=true"
import script from "./status-cell.vue?vue&type=script&lang=ts"
export * from "./status-cell.vue?vue&type=script&lang=ts"
import style0 from "./status-cell.vue?vue&type=style&index=0&id=37a5a1ca&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a5a1ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37a5a1ca')) {
      api.createRecord('37a5a1ca', component.options)
    } else {
      api.reload('37a5a1ca', component.options)
    }
    module.hot.accept("./status-cell.vue?vue&type=template&id=37a5a1ca&scoped=true", function () {
      api.rerender('37a5a1ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project-portfolio/project-portfolio-table/cells/status-cell.vue"
export default component.exports